const routeNameToIdent = (name: string | null | undefined) => (name || 'start').toLowerCase().replace(/ /g, '_');

export default routeNameToIdent;
